module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("发送 ajax 请求")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_c('code', [_vm._v("AjaxPlugin")]), _vm._v(" 插件依赖于 "), _c('a', {
    attrs: {
      "href": "https://github.com/mzabriskie/axios"
    }
  }, [_vm._v("axios")]), _c('br'), _vm._v("\n详细 API 文档请查看："), _c('a', {
    attrs: {
      "href": "https://github.com/mzabriskie/axios"
    }
  }, [_vm._v("axios")])])]), _vm._v(" "), _c('h2', [_vm._v("版本要求")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("AjaxPlugin")]), _vm._v("在"), _c('code', [_vm._v("vux@^2.1.0-rc.20")]), _vm._v("开始支持")]), _vm._v(" "), _c('h2', [_vm._v("引入")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("main.js")]), _vm._v(" 入口文件中引入：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { AjaxPlugin } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\nVue.use(AjaxPlugin)\n")])]), _vm._v(" "), _c('h2', [_vm._v("兼容性问题")]), _vm._v(" "), _c('p', [_vm._v("需要注意的是"), _c('code', [_vm._v("axios")]), _vm._v("是基于"), _c('code', [_vm._v("Promise")]), _vm._v("的，因此如果你需要兼容低版本浏览器("), _c('a', {
    attrs: {
      "href": "http://caniuse.com/#feat=promises"
    }
  }, [_vm._v("caniuse")]), _vm._v(")，需要引入"), _c('code', [_vm._v("polyfill")]), _vm._v("。")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Polyfill")]), _vm._v(" 推荐使用 "), _c('a', {
    attrs: {
      "href": "https://github.com/stefanpenner/es6-promise"
    }
  }, [_vm._v("es6-promise")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'es6-promise'")]), _vm._v(").polyfill()\n")])]), _vm._v(" "), _c('h2', [_vm._v("全局使用")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("Vue.http.post("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'/api'")]), _vm._v(").then()\n")])]), _vm._v(" "), _c('h2', [_vm._v("组件中使用")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n  created () {\n    "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$http.post("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'/api'")]), _vm._v(").then("), _c('span', {
    staticClass: "hljs-function"
  }, [_vm._v("("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("{data}")]), _vm._v(") =>")]), _vm._v(" {\n      "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("console")]), _vm._v(".log(data)\n    })\n  }\n}\n")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5eb6adf0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-5eb6adf0"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/vue-ajax-163.vue
// module id = 2790
// module chunks = 231